import { Reducer, AnyAction, Dispatch } from 'redux';
import { MaterialCtxState } from './type';
import { listMaterials } from '../../api/material';

export const SET_MATERIALS = 'material/setList';
export const SET_CUR_MATERIAL = 'material/setCur';

const defaultState: MaterialCtxState = {
    curMaterialId: '',
    materials: [],
    loaded: false,
};

const reducer: Reducer<MaterialCtxState> = (
    state: MaterialCtxState = defaultState,
    action: AnyAction,
) => {
    switch (action.type) {
        case SET_MATERIALS:
            return {
                ...state,
                materials: action.payload.materials,
                loaded: true,
                // 首次加载若还没选, 默认选第一个材料 (蓝图: "材料详情"默认展示列表第一项)
                curMaterialId:
                    state.curMaterialId ||
                    (action.payload.materials[0]?.xcode ?? ''),
            };
        case SET_CUR_MATERIAL:
            return { ...state, curMaterialId: action.payload.xcode };
        default:
            return state;
    }
};

// load 的并发守卫: 调用方 (Sidebar) 只以 loaded 判断是否触发, 但请求返回前
// loaded 一直是 false, StrictMode 双跑 effect / 多组件同时触发会重复请求.
let loading = false;

const actions = {
    setCur(xcode: string) {
        return { type: SET_CUR_MATERIAL, payload: { xcode } };
    },
    load() {
        return async (dispatch: Dispatch) => {
            if (loading) return;
            loading = true;
            try {
                const res = await listMaterials({ pageSize: 200 });
                dispatch({
                    type: SET_MATERIALS,
                    payload: { materials: res.list || [] },
                });
            } catch {
                dispatch({ type: SET_MATERIALS, payload: { materials: [] } });
            } finally {
                loading = false;
            }
        };
    },
};

export default { reducer, actions };
